import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, getDocs, query, where } from 'firebase/firestore';
import './HomeSalones.css';

const SedeCard = ({ sede, onSelect }) => (
  <div className="sede-card-home" onClick={() => onSelect(sede)}>
    <img src={sede.imageUrl} alt={sede.title} className="sede-card-image-home" />
    <div className="sede-card-overlay-home">
      <h3 className="sede-card-title-home">{sede.title}</h3>
    </div>
  </div>
);

function HomeSalones({ id }) {
  const [sedes, setSedes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSedes = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, 'eventSpaces'), where('type', '==', 'sede'));
        const querySnapshot = await getDocs(q);
        const fetchedSedes = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setSedes(fetchedSedes);

        if (fetchedSedes.length > 0) {
          const randomSede = fetchedSedes[Math.floor(Math.random() * fetchedSedes.length)];
          setBackgroundImageUrl(randomSede.imageUrl);
        }

      } catch (err) {
        setError('No se pudieron cargar las sedes. Intente de nuevo más tarde.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSedes();
  }, []);

  const handleSedeSelect = (sede) => {
    navigate(`/salones?sede=${sede.id}`);
  };

  const sectionStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${backgroundImageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed', // Optional: for a parallax-like effect
  };


  return (
    <section id={id} className="home-salones-section" style={backgroundImageUrl ? sectionStyle : {}}>
      <div className="home-salones-header">
        <h2 className="home-salones-main-title">Salones y Eventos</h2>
        <p className="home-salones-subtitle">Elige una de nuestras sedes y haz clic para empezar a configurar tu evento perfecto.</p>
      </div>
      {loading && <p>Cargando sedes...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && !error && (
        <div className="sedes-grid-home">
          {sedes.map(sede => (
            <SedeCard key={sede.id} sede={sede} onSelect={handleSedeSelect} />
          ))}
        </div>
      )}
    </section>
  );
}

export default HomeSalones;
